import { BodyText } from "@/components/ui/Text";

export const WaitTimeMessage = () => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <BodyText size="xs" textColor="primary">
        We'll be with you shortly.
      </BodyText>
    </div>
  );
};
